/*
 * Copyright (c) 2019-present Sonatype, Inc.
 * This program and the accompanying materials are made available under
 * the terms of the Eclipse Public License 2.0 which accompanies this
 * distribution and is available at https://www.eclipse.org/legal/epl-2.0/.
 */
export var allThreatLevelCategories = ['unspecified', 'none', 'low', 'moderate', 'severe', 'critical'];
export var allThreatLevelNumbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export var categoryByPolicyThreatLevel = Object.freeze([
    'none',
    'low',
    'moderate',
    'moderate',
    'severe',
    'severe',
    'severe',
    'severe',
    'critical',
    'critical',
    'critical'
]);
//# sourceMappingURL=threatLevels.js.map